<script>
  import options from './ContentCarousel.options'
  export default options
</script>

<template>
  <article class="kb-content-carousel" aria-roledescription="carousel" aria-describedby="content-carousel-title" ref="componentRootEl">
    <h2 v-if="getLabel('contentCarouselTitle') && getLabel('contentCarouselTitle').trim() !== ''" class="kb-content-carousel__title" id="content-carousel-title">{{ getLabel('contentCarouselTitle') }}</h2>
    <div :id="carouselId" class="glide">
      <div class="kb-content-carousel__controls" data-glide-el="controls">
        <button class="kb-content-carousel__arrow" data-glide-dir="<" aria-controls="content-carousel-slides" aria-label="Forrige" ref="prevBtn">
          <div class="kb-ui-icon kb-ui-icon--ui-chevron-down"></div>
        </button>
        <button class="kb-content-carousel__arrow" data-glide-dir=">" aria-controls="content-carousel-slides" aria-label="Næste" ref="nextBtn">
          <div class="kb-ui-icon kb-ui-icon--ui-chevron-up"></div>
        </button>
      </div>

      <div class="glide__track" data-glide-el="track" ref="root">
        <div class="glide__slides" aria-live="polite" id="content-carousel-slides">
          <template v-for="(data,index) in contentJson">
            <p class="glide__slide kb-content-carousel__card" role="group" aria-roledescription="karusselelement" :aria-label="`${index+1} af ${contentJson.length}`" :data-index="`${index}`">
              <!-- OBS! :content attribute on component specifically unique for ThemeCard added later as option in ContentCarousel (different from inuform :data attribute)-->
              <component :is="displayProperties.card" :data="data" :content="data" :truncateSummary="truncateSummary"></component>
            </p>
          </template>
        </div>
      </div>
    </div>

    <div class="kb-content-carousel__bottom">
      <template v-if="link?.href">
        <a :href="link.href" :target="link.target" class="kb-content-carousel__bottom__link">
          <span>
            {{getLabel('contentCarouselLinkText')}}
          </span>
          <div class="kb-content-carousel__bottom__link-icon">
            <svg width="17" height="10" fill="none" xmlns="http://www.w3.org/2000/svg"><g stroke="#E8001D"><path d="m12.167 1 3.623 4-3.623 4" stroke-linejoin="round"/><path d="M11.746 5H0"/></g></svg>
          </div>
        </a>
      </template>
    </div>
  </article>
</template>
